import * as React from 'react'
import { SVGProps } from 'react'
const SvgPercentBoxIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		style={{
			width: '1.5rem',
			height: '1.5rem',
		}}
		viewBox="0 0 24 24"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="currentColor"
			d="M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m0 16H5V5h14v14m-2-3.78c0 .98-.8 1.78-1.78 1.78s-1.77-.8-1.77-1.78.79-1.77 1.77-1.77 1.78.79 1.78 1.77m-8.5 1.81L7 15.53 15.53 7l1.5 1.5-8.53 8.53m-1.45-8.2c0-.99.79-1.78 1.78-1.78.98 0 1.77.79 1.77 1.78 0 .98-.79 1.77-1.77 1.77-.99 0-1.78-.79-1.78-1.77Z"
		/>
	</svg>
)
export default SvgPercentBoxIcon
